export default __webpack_public_path__ + "static/media/ooo2.fe136ab4.gif";